module.exports = __webpack_public_path__ + "img/symbol_2.5915f1e7.png";